module.exports = __webpack_public_path__ + "img/ser9.5726147f.png";